<template>
    <div class="DateTimePickerDay__container" @click="pickDay({date:day.date, index: index})">
        <div class="DateTimePickerDay" v-bind:class="{ 'DateTimePickerDay_current': day.isCurrentMonth, 'DateTimePickerDay_selected': day.isSelected}">
            <div class="DateTimePickerDay__name" v-once>
                {{day.name}}
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions } from 'vuex';

    export default {
        name: 'DateTimePickerDay',
        props: ['day', 'index'],
        methods: {
            ...mapActions({
                pickDay: 'dateTimePicker/pickDay'
            })
        }
    };
</script>


<style>
    .DateTimePickerDay__container {
        width: 14.285%;
    }

    .DateTimePickerDay {
        width: 100%;
        cursor: pointer;
        display: flex;
        flex-direction: column;
        color: #ccc;
    }

        .DateTimePickerDay:hover {
            background-color: #eee;
        }

    .DateTimePickerDay_current {
        color: #000;
    }

    .DateTimePickerDay_selected {
        color: #fff;
        background-color: rgb(66, 66, 66);
    }

        .DateTimePickerDay_selected:hover {
            background-color: rgb(66, 66, 66);
        }

    .DateTimePickerDay__name {
        text-align: center;
        flex: 1 1 auto;
        font-size: 1.25rem;
        padding: 8px 0 8px 0;
    }

</style>



// WEBPACK FOOTER //
// DateTimePickerDay.vue?5a0c326f